export default __webpack_public_path__ + "static/media/l2.a3905817.jpg";